"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEventsNames = void 0;
const business_constants_1 = require("@contentsquare/business-constants");
var DataEventsNames;
(function (DataEventsNames) {
    DataEventsNames["Errors"] = "errors";
    DataEventsNames["ErrorsApi"] = "errorsApi";
    DataEventsNames["customErrors"] = "customErrors";
})(DataEventsNames || (DataEventsNames = {}));
exports.AnalyticsEventsNames = Object.assign(Object.assign({}, business_constants_1.FrictionsNames), DataEventsNames);
//# sourceMappingURL=events.response.js.map